module.exports = __webpack_public_path__ + "static/favicon4-356c0807f2dcdd376ae26a604f208c38.jpg";